import { makeRequest, Service, identify } from 'utils/http';
import { CreateDeliveryRequest } from 'trace-backend-sdk';

export async function createDeliveryApi(delivery: CreateDeliveryRequest) {
  return makeRequest(Service.createDelivery(delivery, await identify()));
}
